module.exports = __webpack_public_path__ + "static/media/map-section.dbef8018.png";